<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="制成大类" prop="categoryId">
                <el-select v-model="queryCondition.categoryId" filterable>
                  <el-option :key="index" v-for="(item,index) in categoryOptions" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="制成编码" prop="processCode">
                <el-input v-model="queryCondition.processCode" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="制成名称" prop="processName">
                <el-input v-model="queryCondition.processName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态" prop="status">
                <ic-select table="TT_PROC" field="STATUS" clearable v-model="queryCondition.status" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onConfirm" v-if="isDialog">确认</el-button>
        <el-button size="mini" @click="onCancel" v-if="isDialog">取消</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onAddProcess" v-if="!isDialog" v-acl="PROC_PROCESS_MANAGE_MAINTAIN">新增制成</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onAddCategory" v-if="!isDialog" v-acl="PROC_PROCESS_MANAGE_MAINTAIN">新增大类</el-button>
        <el-button size="mini" class="btn" type="danger" @click="onBatchDel" v-if="!isDialog" v-acl="PROC_PROCESS_MANAGE_MAINTAIN">批量删除</el-button>
      </el-row>
      <el-row>
        <el-table :data="tableData" @selection-change="handleSelectionChange" max-height="425" border stripe style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="categoryId" sortable :sort-method="(a,b) => sortMethods(a ,b , 'categoryId')" label="制成大类" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.categoryCode&&scope.row.categoryName?scope.row.categoryCode+'-'+scope.row.categoryName:''}}
            </template>
          </el-table-column>
          <el-table-column prop="processCode" sortable :sort-method="(a,b) => sortMethods(a ,b , 'processCode')" label="制成编码" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="processName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'processName')" label="制成名称" min-width="250" show-overflow-tooltip></el-table-column>
          <el-table-column prop="processDesc" sortable :sort-method="(a,b) => sortMethods(a ,b , 'processDesc')" label="制成描述" min-width="250" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" sortable :sort-method="(a,b) => sortMethods(a ,b , 'status')" label="状态" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 'ACTIVE' ? 'success' : 'danger'">
                {{ scope.row.status === 'ACTIVE' ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" v-if="!isDialog">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="handleEdit(scope.row)" v-acl="PROC_PROCESS_MANAGE_MAINTAIN">编辑</el-button>
              <el-button type="danger" size="small" @click="handleDelete(scope.row)" v-acl="PROC_PROCESS_MANAGE_MAINTAIN">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
          </el-pagination>
        </div>
      </el-row>
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" @close="onClose">
        <el-form ref="formData" :model="formData" :rules="formRules" label-width="90px">
          <el-form-item v-if="formData.itemType === 'process'" label="制成大类" prop="categoryId">
            <el-select v-model="formData.categoryId" filterable style="width:100%">
              <el-option :key="index" v-for="(item,index) in categoryOptions" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="编码" prop="code">
            <el-input v-model="formData.code" disabled />
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="formData.name" :placeholder="formData.itemType === 'category' ? '请输入大类名称' : '请输入制成名称'" maxlength="50" show-word-limit />
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input v-model="formData.desc" type="textarea" :rows="3" :placeholder="formData.itemType === 'category' ? '请输入大类描述' : '请输入制成描述'" maxlength="500" show-word-limit />
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <ic-select table="TT_PROC" field="STATUS" :disabled="operationType=='add'" clearable v-model="formData.status" style="width:100%"></ic-select>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center">
          <el-button size="mini" class="btn" type="primary" @click="onSaveProcess" :disabled="isSaveDisabled" :loading="isSaveLoading" v-if="formData.itemType === 'process'">确定</el-button>
          <el-button size="mini" class="btn" type="primary" @click="onSaveCategory" :disabled="isSaveDisabled" :loading="isSaveLoading" v-else>确定</el-button>
          <el-button size="mini" class="btn" type="primary" @click="onClose">取消</el-button>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import processApi from "@/api/Process/index";
import paginationMixin from '@/mixins/pagitionMixin';
import IcSelect from "@/components/common/icSelect";
export default {
  name: 'Window',
  mixins: [paginationMixin],
  components: { IcSelect },
  props: ['isDialog', 'processSelected'],
  data() {
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        categoryId: "",
        processCode: "",
        processName: "",
        status: "",
      },
      totalCount: 0,
      pages: 1,
      tableData: [],
      categoryOptions: [],
      dialogTitle: "",
      dialogVisible: false,
      isSaveDisabled: false,
      isSaveLoading: false,
      formData: {
        processId: "",
        code: "",
        name: "",
        desc: "",
        categoryId: "",
        itemType: "",
        status: 'ACTIVE',
      },
      formRules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        categoryId: [{ required: true, message: "请选择制成大类", trigger: "change" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      selectedRows: [],
      operationType: "",
      selectedProcessCode: []
    };
  },
  watch: {
    processSelected: {
      handler(newVal) {
        console.log("🚀 ~ handler ~ newVal:", newVal)
        this.selectedProcessCode = [...newVal]
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.queryData()
    this.getProcessCategory()
  },
  methods: {
    queryData() {
      if (this.isDialog) {
        this.queryCondition.status = 'ACTIVE'
      }
      processApi.getProcessBaseLists(this.queryCondition).then(res => {
        console.log("🚀 ~ queryData ~ res:", res)
        if (res.code == '200') {
          this.tableData = res.data.records
          this.totalCount = res.data.total
        }
      })
    },
    getProcessCategory() {
      this.categoryOptions = []
      processApi.getProcessCategory().then(res => {
        console.log("🚀 ~ getProcessCategory ~ res:", res)
        res.data.forEach(ele => {
          this.categoryOptions.push({
            label: ele.categoryCode + '-' + ele.categoryName,
            value: ele.categoryId
          })
        })
      })
    },
    onAddProcess() {
      this.dialogTitle = "新增制成";
      this.operationType = 'add'
      Object.assign(this.formData, {
        processId: "",
        code: "",
        name: "",
        desc: "",
        categoryId: "",
        itemType: "process",
        status: 'ACTIVE',
      });
      this.dialogVisible = true;
    },
    onAddCategory() {
      this.dialogTitle = "新增制成大类";
      this.operationType = 'add'
      Object.assign(this.formData, {
        processId: "",
        code: "",
        name: "",
        desc: "",
        categoryId: "",
        itemType: "category",
        status: 'ACTIVE',
      });
      this.dialogVisible = true;
    },
    onSaveCategory() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          var obj = {
            categoryName: this.formData.name,
            categoryDesc: this.formData.desc,
            status: this.formData.status,
          }
          this.isSaveDisabled = true
          this.isSaveLoading = true
          processApi.addProcessCategory(obj).then(res => {
            if (res.code == '200') {
              this.$message.success('新增成功')
              this.onClose()
            }
            this.isSaveDisabled = false
            this.isSaveLoading = false
          })
        }
      })
    },
    onSaveProcess() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          var obj = {
            processId: this.formData.processId,
            processName: this.formData.name,
            processDesc: this.formData.desc,
            status: this.formData.status,
            categoryId: this.formData.categoryId,
          }
          console.log("🚀 ~ onSaveProcess ~ obj:", obj)
          this.isSaveDisabled = true
          this.isSaveLoading = true
          processApi.addOrUpdateProcess(obj).then(res => {
            if (res.code == '200') {
              if (this.operationType == 'add') {
                this.$message.success('新增成功')
              } else {
                this.$message.success('保存成功')
              }
              this.onClose()
            }
            this.isSaveDisabled = false
            this.isSaveLoading = false
          })
        }
      })
    },
    onClose() {
      this.dialogTitle = "";
      this.operationType = ''
      this.$refs['formData'].resetFields()
      this.dialogVisible = false;
      this.queryData();
      this.getProcessCategory()
    },
    onBatchDel() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      var processIds = this.selectedRows.map(ele => ele.processId)
      console.log("🚀 ~ onBatchDel ~ processIds:", processIds)
      this.$confirm(`确定要删除选中的 ${this.selectedRows.length} 条数据吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          processApi.batchDeleteProcess(processIds).then(res => {
            console.log("🚀 ~ onBatchDel ~ res:", res)
            if (res.code == '200') {
              this.$message.success('删除成功')
              this.queryData()
            }
          })
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    handleEdit(row) {
      this.dialogTitle = "编辑制成";
      this.operationType = 'edit'
      Object.assign(this.formData, {
        processId: row.processId,
        code: row.processCode,
        name: row.processName,
        desc: row.processDesc,
        categoryId: row.categoryId,
        itemType: "process",
        status: row.status,
      });
      this.dialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm(`确定要删除制成"${row.processCode + '-' + row.processName}"吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          processApi.deleteProcess(row.processId).then(res => {
            if (res.code == '200') {
              this.$message.success('删除成功')
              this.queryData()
            }
          })
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    onSearch() {
      this.queryCondition.pageNum = 1;
      this.queryData()
    },
    onReset() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        processCategory: "",
        processCode: "",
        processName: "",
        status: "",
      }
      this.queryData()
    },
    onConfirm() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请至少选择一条数据");
        return;
      }
      // 检查是否有重复勾选
      const hasDuplicate = this.selectedRows.some(item => this.selectedProcessCode.includes(item.processCode));
      console.log("🚀 ~ onConfirm ~ hasDuplicate:", hasDuplicate)
      if (hasDuplicate) {
        this.$message.warning("存在已勾选的制成,请重新勾选");
        return
      }
      var processIds = this.selectedRows.map(ele => ele.processId)
      console.log("🚀 ~ addProcess ~ processIds:", processIds)
      processApi.getProcessParamList(processIds).then((res) => {
        console.log("🚀 ~ onConfirm ~ res:", res)
        var data = JSON.parse(JSON.stringify(res.data))
        console.log("🚀 ~ onConfirm ~ data:", data)
        if (data && data.length > 0) {
          data.forEach(process => {
            if (process.factors && process.factors.length > 0) {
              process.factors.forEach(factor => {
                if (factor.params && factor.params.length > 0) {
                  factor.params.forEach(param => {
                    this.$set(param, 'paramType', 'PLAIN')
                    this.$set(param, 'paramTypeText', '普通参数')
                  })
                }
              })
            }
          })
          console.log("🚀 ~ onConfirm ~ data2222222:", data)
          this.queryCondition.status = ''
          this.$emit('addProcess', data)
        }
      })

    },
    onCancel() {
      this.queryCondition.status = ''
      this.$emit('onCancelProcess')
    },
    sortMethods(a, b, proptype) {
      var prop
      if (proptype === 'updateDate') {
        prop = 'updateDateMiss'
      } else {
        prop = proptype
      }
      if (a[prop] === null || a[prop] === undefined) {
        return 1; // 将空值排在后面
      } else if (b[prop] === null || b[prop] === undefined) {
        return -1; // 将空值排在后面
      } else {
        // 自定义排序逻辑
        // return a[prop] - b[prop]; // 示例中使用数字类型的比较
        if (typeof a[prop] === 'string' && typeof b[prop] === 'string') {
          return a[prop].localeCompare(b[prop])
        } else {
          return a[prop] - b[prop];
        }
      }
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
  }
}
</script>
  